import React from "react";
import {currencyService} from "../jwt/_services/promotions/currencyService";

export const currencyProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await currencyService.getAll();
        return listItems.map((itemData) => {
            return (
                {
                    id: itemData?.currency,
                    value: itemData?.currency + ' - ' + itemData?.name,
                    idCurrency: itemData?.id,
                    label: <label>{ itemData.currency.toUpperCase() + ' - '  } <b>{ itemData.name }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await currencyService.getItem(id);
        let show = item.currency != null && item.currency !== "" ? item.currency : "";
        return (
            {
                id: item.id,
                value: show,
                label: <div><label>{show}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}